import React, { FormEvent, useState } from "react";
import { changeAccountPassword } from "../../../services/AccountApi";
import { useAccountTranslation } from "../translations";

const ChangePassword: React.FC = () => {
    const { t } = useAccountTranslation();
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmation, setConfirmation] = useState("");
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);

    const submit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setError(null);
        setSuccess(false);

        if (newPassword.length < 8) {
            setError(t("passwordRequirements"));
            return;
        }
        if (newPassword === currentPassword) {
            setError(t("passwordMustBeDifferent"));
            return;
        }
        if (newPassword !== confirmation) {
            setError(t("passwordMismatch"));
            return;
        }

        setSaving(true);
        try {
            await changeAccountPassword(currentPassword, newPassword);
            setCurrentPassword("");
            setNewPassword("");
            setConfirmation("");
            setSuccess(true);
        } catch {
            setError(t("passwordChangeError"));
        } finally {
            setSaving(false);
        }
    };

    return <form className="portal-password-form" onSubmit={submit}>
        <div className="portal-security-control-heading">
            <strong>{t("changePassword")}</strong>
            <p>{t("changePasswordDescription")}</p>
        </div>

        {error && <div className="alert alert-danger" role="alert">{error}</div>}
        {success && <div className="alert alert-success" role="status">{t("passwordChanged")}</div>}

        <div className="portal-settings-field-grid">
            <label htmlFor="account-current-password">
                <span>{t("currentPassword")}</span>
                <input
                    id="account-current-password"
                    type="password"
                    autoComplete="current-password"
                    value={currentPassword}
                    onChange={event => setCurrentPassword(event.target.value)}
                    required
                />
            </label>
            <label htmlFor="account-new-password">
                <span>{t("newPassword")}</span>
                <input
                    id="account-new-password"
                    type="password"
                    autoComplete="new-password"
                    value={newPassword}
                    onChange={event => setNewPassword(event.target.value)}
                    minLength={8}
                    maxLength={72}
                    aria-describedby="account-password-requirements"
                    required
                />
            </label>
            <label htmlFor="account-confirm-password">
                <span>{t("confirmNewPassword")}</span>
                <input
                    id="account-confirm-password"
                    type="password"
                    autoComplete="new-password"
                    value={confirmation}
                    onChange={event => setConfirmation(event.target.value)}
                    minLength={8}
                    maxLength={72}
                    required
                />
            </label>
        </div>
        <small id="account-password-requirements" className="portal-field-help">
            {t("passwordRequirements")}
        </small>
        <div className="portal-button-row">
            <button
                type="submit"
                className="portal-button portal-button-primary"
                disabled={saving || !currentPassword || !newPassword || !confirmation}
            >
                {saving ? t("changingPassword") : t("changePassword")}
            </button>
        </div>
    </form>;
};

export default ChangePassword;
